<div class="flex__child--auto">
  <agr-chart *ngIf="!!chartSeries" [options]="chartOptions" [dataSource]="chartSeries"></agr-chart>
</div>
